import { Spinner } from 'react-bootstrap';

function ContainerSpinner() {


  return (
    <div id="chat_overlay" class="d-flex rounded-0 align-items-center justify-content-between">
        <div className='m-auto py-2 text-center'>
            <Spinner animation="border" role="status" variant="light">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>

    </div>
  );
}

export { ContainerSpinner };
